module.exports = __webpack_public_path__ + "static/media/Icons_info_dark.ab6a6ee0.svg";